import { render, staticRenderFns } from "./FluxRegaloReservaStep2.vue?vue&type=template&id=5e50ca71"
import script from "./FluxRegaloReservaStep2.vue?vue&type=script&lang=js"
export * from "./FluxRegaloReservaStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports